"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useDebouncedState = require("./useDebouncedState.cjs");
function useDebouncedValue(value, options, selector) {
  const [debouncedValue, setDebouncedValue, debouncer] = useDebouncedState.useDebouncedState(
    value,
    options,
    selector
  );
  react.useEffect(() => {
    setDebouncedValue(value);
  }, [value, setDebouncedValue]);
  return [debouncedValue, debouncer];
}
exports.useDebouncedValue = useDebouncedValue;
//# sourceMappingURL=useDebouncedValue.cjs.map
